import { createFileRoute } from "@tanstack/react-router"

import { projectsArchivedSearchSchema } from "@/features/projects/projects-search-schema"
import { SettingsArchivedProjectsPage } from "@/pages/settings/projects/archived"

export const Route = createFileRoute("/_authenticated/settings/projects/archived")({
  validateSearch: (search) => projectsArchivedSearchSchema.parse(search),
  component: SettingsArchivedProjectsPage,
})
